import React from "react";
const TextInputTwoRowReverse = ({
  inputProps = {},
  labelClass = "label-control",
  inputClass = "form-control input-sm",
  wrapperClass = "form-group",
  inputWrapClass = "col-md-8",
  labelText = "",
}) => {
  return (
    <div className={wrapperClass}>
      <div class={inputWrapClass}>
        <input
          type="text"
          className={inputClass}
          placeholder=""
          {...inputProps}
        />
      </div>
      <label className={labelClass}>{labelText}</label>
    </div>
  );
};
export default TextInputTwoRowReverse;
